<template>
    <div id="page-register" class="auth-form d-flex flex-column h-100">
        <nav-header></nav-header>
        <div class="container flex-fill">
            <div v-if="videoPage == ''" class="row h-100">
                <div v-if="currentStep == 'name'" class="register-step step-name text-center col-md-7 col-lg-5">
                    <form @submit.prevent="nextStep">
                        <h3 class="d-md-none mb-5">{{ $t('login.auth_username_title') }}</h3>
                        <h2 class="d-none d-md-block mt-4 mb-5">{{ $t('login.auth_username_title') }}</h2>

                        <h5 class="mb-3">{{ $t('login.auth_username_avatar_lable') }}</h5>
                        <div class="form-group">
                            <a @click.prevent="$refs.avatarPopup.show();btnSfx();" href="#" class="avatar-image"><img :src="user.avatarUrl"/></a>
                        </div>
                        <div class="form-group mb-5">
                            <b-button @click="$refs.avatarPopup.show();btnSfx();"  variant="success" size="lg" class="pl-5 pr-5">IZABERI SLIKU</b-button>
                        </div>
                        <div class="form-group mb-5">
                            <label>{{ $t('login.auth_username_name_label') }} <small class="text-primary ml-5">{{ $t('login.auth_username_name_info_label') }}</small></label>
                            <b-form-input v-model="user.username" type="text" size="lg"></b-form-input>
                        </div>

                        <div class="form-group">
                            <b-button @click="nextStep();btnSfx();" type="button" variant="primary" size="lg" class="pl-5 pr-5" >{{ $t('login.auth_username_btn_next') }}</b-button>
                        </div>
                    </form>
                </div>
                <div v-if="currentStep == 'video'" class="register-step step-video text-center col-md-7 col-lg-5">
                    <h3 class="d-md-none mb-5">{{ $t('login.auth_video_title') }}</h3>
                    <h2 class="d-none d-md-block mt-4 mb-5">{{ $t('login.auth_video_title') }}</h2>

                    <img src="/images/auth/auth_video_top.png" alt="Adbalu" class="vh-10 mb-4" />
                    <h5 class="mb-4 text-primary">{{ $t('login.auth_video_description') }}</h5>
                    <hr class="col-3 m-auto" />
                    <a @click.prevent="playDemoVideo();btnSfx();" href="#" id="authVideoHolder">
                        <video :src="'/video/'+(user.mtsCustomer ? 'mts': 'default')+'/bear-play.mp4'" type="video/mp4" class="vh-40" muted autoplay loop playsinline>
                            Your browser does not support the video.
                        </video>
                        <div class="authVideoPointer"><div class="pointer"></div></div>
                        <h4 class="text-orange"><b>{{ $t('login.auth_video_start_info') }}</b></h4>
                    </a>
                </div>
                <div v-if="currentStep == 'info'" class="register-step step-info text-center col-md-7 col-lg-6">
                    <form @submit.prevent="nextStep">
                    
                        <div class="user-resources justify-content-lg-center mt-3">
                            <ul class="animate__animated animate__fadeInDown w-50">
                                <li><img src="/images/token.png">{{ userCollectedAwards.abbr(true) }}</li>
                            </ul>
                        </div>

                        <h4>{{ $t('login.auth_info_title') }}</h4>
                        <img src="/images/auth/info_top.png" class="vh-5 mb-2" />
                        <p class="text-primary pl-3 pr-3">{{ $t('login.auth_info_description') }}</p>

                        <div class="d-flex gender-holder justify-content-center mb-5">
                            <a @click.prevent="gender = 'MALE';btnSfx();" :class="gender == 'MALE' ? 'selected' : ''" href="#">
                               <img :src="'/images/theme/'+(user.mtsCustomer ? 'mts': 'default')+'/bear/male-default.png'"/> 
                               <span>{{ $t('login.auth_info_gender_male') }}</span>
                            </a>
                            <a @click.prevent="gender = 'FEMALE';btnSfx();" :class="gender == 'FEMALE' ? 'selected' : ''" href="#">
                               <img :src="'/images/theme/'+(user.mtsCustomer ? 'mts': 'default')+'/bear/female-default.png'"/> 
                               <span>{{ $t('login.auth_info_gender_female') }}</span>
                            </a>
                        </div>

                        <h4 class="mb-3">{{ $t('login.auth_info_age_label') }}</h4>
                        <div class="form-group">
                            <select v-model="birthYear" class="form-control m-auto w-auto pl-4 pr-4">
                                <option v-for="y in yearsArray(91)" :key="y" :value="y">{{ y }}</option>
                            </select>
                        </div>
                        <p class="text-primary">{{ $t('login.auth_info_award') }}</p>

                        <h4 class="text-center text-yellow mb-4">
                            <b><img src="/images/token-no-border.png" class="mr-3"/> {{ config.registrationBirthYearGiftTokens.abbr(true) }}</b>
                        </h4>

                        <div class="form-group">
                            <b-button @click="nextStep();btnSfx();" type="button" variant="primary" size="lg" class="pl-5 pr-5" >{{ $t('login.auth_info_btn_next') }}</b-button>
                        </div>
                    </form>
                </div>
                <div v-if="currentStep == 'invitations'" class="register-step step-invitations text-center col-md-8 col-lg-6">
                    
                    <div class="user-resources mt-3 justify-content-lg-center">
                        <ul class="animate__animated animate__fadeInDown w-50">
                            <li><img src="/images/token.png">{{ userCollectedAwards.abbr(true) }}</li>
                        </ul>
                    </div>

                    <h4 class="mb-4 mt-2">{{ $t('login.auth_referral_title') }}</h4>
                    <p class="text-primary">{{ $t('login.auth_referral_description') }}</p>

                    <div class="referral-info d-flex justify-content-center mb-4 vh-30">
                        <div class="referral-info-you flex-fill">
                            <div class="flex-fill">
                                <span class="mt-2"><img src="/images/joker.png"/> <b>{{ config.registrationReferralAwardUserJokers }}</b></span>
                                <p class="mb-3 mt-auto"><b>{{ config.registrationReferralAwardUserTokens }}</b></p>
                            </div>
                            <span class="pt-2">{{ $t('login.auth_referral_info_you') }}</span>
                        </div>
                        <div class="referral-info-frend flex-fill">
                            <div class="flex-fill">
                                <span class="mt-2"><img src="/images/joker.png"/> <b>{{ config.registrationReferralAwardReferralJokers }}</b></span>
                                <p class="mb-3 mt-auto"><b>{{ config.registrationReferralAwardReferralTokens }}</b></p>
                            </div>
                            <span class="pt-2">{{ $t('login.auth_referral_info_frend') }}</span>
                        </div>
                    </div>

                    <div class="form-group mb-5">
                        <b-button @click="openSharePopup();btnSfx();" type="button" variant="orange" size="lg" class="m-auto w-auto pl-4 pr-4" ><i class="fas fa-share mr-2"></i> {{ $t('login.auth_referral_shere_btn') }}</b-button>
                    </div>

                    <div class="form-group">
                        <router-link :to="{ name: 'home' }" class="btn btn-primary btn-lg pl-5 pr-5" >{{ $t('login.auth_referral_btn_next') }}</router-link>
                    </div>

                </div>
            </div>
            
            <div v-if="videoPage == 'question'" class="row h-100">
                <div class="text-center col-md-7 col-lg-6 ml-auto mr-auto">
                    <div class="user-resources mb-3 justify-content-lg-center absolute">
                        <ul class="animate__animated animate__fadeInDown w-50">
                            <li><img src="/images/token.png">{{ userCollectedAwards.abbr(true) }}</li>
                        </ul>
                    </div>
                    <adquiz-question :demo="true" :adQuiz="adQuiz" @eventClose="videoPage = ''" @eventNextVideo="nextStep" @eventDemoCollected="videoFinished"/>
                </div>
            </div>

            <video-player :demo="true" v-if="videoPage == 'video'" :adQuiz="adQuiz" @eventClose="videoPage = ''" @eventEnded="videoPage = 'question'" />
            <avatar-popup ref="avatarPopup" @updateAvatar="setAvatar"></avatar-popup>
            <share-popup ref="sharePopup"></share-popup>
            
        </div>
        <footer-text></footer-text>
    </div>
</template>
<script>
import app from '../app'
import api from '../api'
import Header from '../components/Header.vue' 
import Footer from '../components/Footer.vue'
import AvatarPopup from '../components/AvatarPopup.vue'
import VideoPlayer from '../components/VideoPlayer.vue'
import AdQuizQuestion from '../components/AdQuizQuestion.vue'
import SharePopup from '../components/SharePopup.vue'

export default {
    components: { VideoPlayer, AvatarPopup, AdQuizQuestion, SharePopup },
    data () {
        return {
            currentStep: 'name',
            userCollectedAwards: 0,
            isAvatarSet: false,
            user: { username: '', avatarUrl: undefined },

            gender: undefined,
            birthYear: undefined,
            adQuiz: undefined,
            videoPage: '',

            config: {
                registrationBirthYearGiftTokens: 100,
                registrationReferralAwardUserTokens: 100,
                registrationReferralAwardUserJokers: 1,
                registrationReferralAwardReferralTokens: 100,
                registrationReferralAwardReferralJokers: 1,
            }
        }
    },

    created(){
        this.config = this.$store.state.config.data;
    },

    mounted() {
        this.user = {...this.$store.state.auth.user};
        if(this.user.username != undefined) this.isAvatarSet = true;
        this.setStep();

        if(this.user.mtsCustomer)
            document.body.classList.add('theme-mts');
        else
            document.body.classList.remove('theme-mts');

        this.$store.dispatch('sound/bg','BG_Home');
    },
    
    methods: {
        
        btnSfx(){
            this.$store.dispatch('sound/sfx','Button');
        },

        setAvatar(avatarUrl){
            this.user.avatarUrl = avatarUrl;
            this.isAvatarSet = true;
        },

        checkIsAvatarSet(){
            if(!this.isAvatarSet){
                this.$store.dispatch('sound/sfx','Error');
                this.$bvModal.msgBoxOk(this.$t('login.avatar_singin_error_text'), {
                    title: this.$t('login.avatar_singin_error_title'),
                    size: 'sm',
                    buttonSize: 'lg',
                    okTitle: this.$t('base.btn_ok'),
                    modalClass: 'confirmModal',
                    centered: true,
                })
                .then(value => {
                    this.$store.dispatch('sound/sfx','Button');
                });
            }
            return this.isAvatarSet;
        },

        setStep(step){
            if(step == undefined) step = 'name';
            let user = this.$store.state.auth.user;
            this.currentStep = step;
            this.videoPage = "";

            switch(step){
                case "name":
                    if (user.username != undefined && user.username != "" && this.checkIsAvatarSet())
                        this.setStep('video');
                    break;
                case "video":
                    if (this.userCollectedAwards > 0 || user.state != 'UNREGISTERED'){
                        if(this.gender == undefined) this.gender = 'MALE';
                        if(this.birthYear == undefined) this.birthYear = new Date().getFullYear() - 18;
                        this.setStep('info');
                    }
                    break;
                case "info":
                    if (user.state != 'UNREGISTERED'){
                        this.userCollectedAwards += this.config.registrationBirthYearGiftTokens;
                        this.setStep('invitations');
                    }
                    break;
            }
        },


        nextStep(){
            let params = {
                username: this.user.username,
                gender: this.gender,
                birthYear: this.birthYear,
            };

            const $this = this;
            let loader = document.getElementById('loader');
            loader.classList.add("show");

            api.updateMe(params)
                .then(function (response) {
                    $this.$store.dispatch('auth/setUser', response.data);
                    $this.setStep();
                })
                .catch(function (error) {
                    api.baseErrorHendler(error);
                })
                .then(function () {
                    loader.classList.remove("show");
                });
        },


        playDemoVideo(){
            const $this = this;
            let loader = document.getElementById('loader');
            loader.classList.add("show");

            api.adQuizDemo()
                .then(function (response) {
                    $this.adQuiz = response.data;
                    if($this.adQuiz != null){
                        if($this.adQuiz.videoUrl != undefined)
                            $this.videoPage = "video";
                        else
                            $this.videoPage = "question";
                    }
                })
                .catch(function (error) {
                    api.baseErrorHendler(error);
                    $this.videoPage = "";
                })
                .then(function () {
                    loader.classList.remove("show");
                });
        },

        videoFinished(collected){
            this.userCollectedAwards += collected;
        },

        yearsArray(back){
            const year = new Date().getFullYear();
            return Array.from({length: back}, (v, i) => year - back + i + 1);
        },

        openSharePopup(){
            this.$refs.sharePopup.show();
        }

    },

}
</script>